<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0;
  font-family: "Helvetica Neue", Arial, sans-serif;
  background: #f0f2f5;
}
</style>
